<div class="draftBody" style="display: flex; flex-direction: column; flex: 1 1 0; min-height: 0; overflow: hidden;"> <!-- margin-top: 20px; margin-left:20px; margin-right:20px;-->
  <div class="page-range-bar" [class.rtl]="isRtl" (click)="onPageBarClick($event)" style="flex-grow: 0">
    <div class="page-range-track">
      <div class="page-range-fill"
           [style.left.%]="isRtl ? null : (selectedPageRange.start / draft.draftBody.numPages) * 100"
           [style.right.%]="isRtl ? (selectedPageRange.start / draft.draftBody.numPages) * 100 : null"
           [style.width.%]="((selectedPageRange.end - selectedPageRange.start) / draft.draftBody.numPages) * 100">
      </div>
    </div>
    <div class="page-range-labels">
      <span *ngFor="let i of tickValues"
            class="page-range-tick-label"
            [style.left.%]="isRtl ? null : (i / draft.draftBody.numPages) * 100"
            [style.right.%]="isRtl ? (i / draft.draftBody.numPages) * 100 : null"
            [class.in-range]="i >= selectedPageRange.start && i <= selectedPageRange.end">
        {{localizeNumber(i === 0 ? 1 : i)}}
      </span>
    </div>
  </div>
  <div class="spreads" style="flex: 1 1 0; min-height: 0; overflow: auto;">
    <div #contentArea class="content-to-scale" [style.zoom]="scaleValue" style="padding: 20px;">
      <div class="spread" *ngFor="let pageNumber of pageNumbers(selectedPageRange.start, selectedPageRange.end, 2 )">
        <app-spread [resourceId]="draft.draftBody.resource_ID"
                    [draft]="draft"
                    [leftVerticalShift]="draft.draftBody.leftVerticalShift"
                    [leftHorizontalShift]="draft.draftBody.leftHorizontalShift"
                    [rightVerticalShift]="draft.draftBody.rightVerticalShift"
                    [rightHorizontalShift]="draft.draftBody.rightHorizontalShift"
                    [scale]="draft.draftBody.documentScale"
                    [dpi]="288"
                    [leftPageNumber]="pageNumber"
                    [rightPageNumber]="pageNumber + 1"
                    [orgId]="draft.org_ID"
                    [bodyOrCover]="'BODY'"
                    [bindingType]="draft.bindingType"
                    [showRuler]="showRulers"
                    [showGuideLines]="showMarginCheck"
                    [showDebugGrid]="showDebugGrid"
                    [showGutter]="showGutter"
                    [showPageNumbers]="showPageNumbers"
                    [unit]="unit"
                    [zoom]="scaleValue"
                    style="margin-left: auto; margin-right: auto;">
        </app-spread>
      </div>
    </div>
  </div>
  <div class="scale-control-container" [ngClass]="controlPositionClass"
       #interiorToolbar>

    <div class="drag-handle"
         (mousedown)="onDragStart($event)"
         (touchstart)="onDragStart($event)"
         i18n-title="@@Drag to Move" title="Drag to Move">
      <mat-icon>drag_indicator</mat-icon>
    </div>

    <button class="expand-collapse-indicator" (click)="toggleToolbarExpanded()"
            i18n-title="@@Expand/Collapse Controls" title="Expand/Collapse Controls">
      <mat-icon *ngIf="!toolbarExpanded">unfold_more</mat-icon>
      <mat-icon *ngIf="toolbarExpanded">unfold_less</mat-icon>
    </button>


    <div class="shift-control-area">

      <div class="shift-groups-row">
        <div class="shift-group left-shift">
          <label *ngIf="!linkSides" i18n="@@Left Shift">Left Shift</label>
          <label *ngIf="linkSides" i18n="@@Linked Left and Right Shift">Linked Left and Right Shift</label>
          <div class="dpad-and-value">
            <div class="dpad">
              <button class="dpad-btn dpad-up" (click)="changeShift('leftVerticalShift', 9)" i18n-title="@@Up" title="Up">▲</button>
              <div class="dpad-middle-row">
                <button class="dpad-btn dpad-left" (click)="changeShift('leftHorizontalShift', -9)" i18n-title="@@Left" title="Left">◀</button>
                <span class="dpad-center"></span>
                <button class="dpad-btn dpad-right" (click)="changeShift('leftHorizontalShift', 9)" i18n-title="@@Right" title="Right">▶</button>
              </div>
              <button class="dpad-btn dpad-down" (click)="changeShift('leftVerticalShift', -9)" i18n-title="@@Down" title="Down">▼</button>
            </div>
            <div class="shift-values">
              <div class="shift-value-row">
                <span class="shift-label" i18n="@@V">V</span>
                <input type="number" [ngModel]="roundHundredths(draftBody.leftVerticalShift / unitMultiplier)" (change)="changeShiftValue('leftVerticalShift', $event.target.value)" [min]="-20 * 72 / unitMultiplier" [max]="20 * 72 / unitMultiplier">
              </div>
              <div class="shift-value-row">
                <span class="shift-label" i18n="@@H">H</span>
                <input type="number" [ngModel]="roundHundredths(draftBody.leftHorizontalShift / unitMultiplier)" (change)="changeShiftValue('leftHorizontalShift', $event.target.value)" [min]="-20 * 72 / unitMultiplier" [max]="20 * 72 / unitMultiplier">
              </div>
            </div>
          </div>
        </div>

        <div class="shift-group right-shift" *ngIf="!linkSides">
          <label i18n="@@Right Shift">Right Shift</label>
          <div class="dpad-and-value">
            <div class="dpad">
              <button class="dpad-btn dpad-up" (click)="changeShift('rightVerticalShift', 9)" i18n-title="@@Up" title="Up">▲</button>
              <div class="dpad-middle-row">
                <button class="dpad-btn dpad-left" (click)="changeShift('rightHorizontalShift', -9)" i18n-title="@@Left" title="Left">◀</button>
                <span class="dpad-center"></span>
                <button class="dpad-btn dpad-right" (click)="changeShift('rightHorizontalShift', 9)" i18n-title="@@Right" title="Right">▶</button>
              </div>
              <button class="dpad-btn dpad-down" (click)="changeShift('rightVerticalShift', -9)" i18n-title="@@Down" title="Down">▼</button>
            </div>
            <div class="shift-values">
              <div class="shift-value-row">
                <span class="shift-label" i18n="@@V">V</span>
                <input type="number" [ngModel]="roundHundredths(draftBody.rightVerticalShift / unitMultiplier)" (change)="changeShiftValue('rightVerticalShift', $event.target.value)" [min]="-20 * 72 / unitMultiplier" [max]="20 * 72 / unitMultiplier">
              </div>
              <div class="shift-value-row">
                <span class="shift-label" i18n="@@H">H</span>
                <input type="number" [ngModel]="roundHundredths(draftBody.rightHorizontalShift / unitMultiplier)" (change)="changeShiftValue('rightHorizontalShift', $event.target.value)" [min]="-20 * 72 / unitMultiplier" [max]="20 * 72 / unitMultiplier">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="link-sides-toggle">
        <mat-checkbox [ngModel]="linkSides" (change)="onLinkSidesChange($event.checked)" i18n="@@Link Sides">Link Sides</mat-checkbox>
      </div>

      <mat-divider *ngIf="toolbarExpanded"></mat-divider>

      <!-- Trim Size and Units in horizontal row - Hidden in compact mode -->
      <div class="trim-and-units-row" *ngIf="toolbarExpanded">
        <div class="trim-size-section-inline">
          <mat-form-field class="trim-size-select-inline" appearance="outline">
            <mat-label i18n="@@Trim Size">Trim Size</mat-label>
            <mat-select [value]="selectedTrimSize" (selectionChange)="onTrimSizePresetChange($event.value)">
              <mat-option *ngFor="let preset of trimSizePresets" [value]="preset.label" [class.promoted]="preset.isPromoted">
                {{getTrimSizeLabel(preset)}}
              </mat-option>
              <mat-option value="CUSTOM">
                <span *ngIf="selectedTrimSize === 'CUSTOM'">
                  <span i18n="@@Custom">Custom</span> ({{getCustomTrimSizeLabel()}})
                </span>
                <span *ngIf="selectedTrimSize !== 'CUSTOM'" i18n="@@Custom">Custom</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="unit-selector">
          <label i18n="@@Units">Units:</label>
          <button
            [class.active]="unit === 'in'"
            (click)="changeUnits('in')" i18n="@@Inches">in</button>
          <button
            [class.active]="unit === 'mm'"
            (click)="changeUnits('mm')" i18n="@@Millimeters">mm</button>
        </div>
      </div>

      <!-- Custom trim inputs (shown below trim size when editing) -->
      <div *ngIf="editingCustomTrim && toolbarExpanded" class="custom-trim-inputs">
        <mat-form-field class="trim-size-custom-input" appearance="outline">
          <mat-label i18n="@@Width">W</mat-label>
          <input matInput type="number"
                 [ngModel]="getCustomWidthInCurrentUnits()"
                 (ngModelChange)="setCustomWidthFromCurrentUnits($event)"
                 [ngModelOptions]="{standalone: true}"
                 [min]="unit === 'mm' ? 50 : 2"
                 [max]="unit === 'mm' ? 500 : 20"
                 [step]="unit === 'mm' ? 1 : 0.25">
          <span matSuffix>{{unit === 'mm' ? 'mm' : '"'}}</span>
        </mat-form-field>
        <span class="trim-size-x">×</span>
        <mat-form-field class="trim-size-custom-input" appearance="outline">
          <mat-label i18n="@@Height">H</mat-label>
          <input matInput type="number"
                 [ngModel]="getCustomHeightInCurrentUnits()"
                 (ngModelChange)="setCustomHeightFromCurrentUnits($event)"
                 [ngModelOptions]="{standalone: true}"
                 [min]="unit === 'mm' ? 50 : 2"
                 [max]="unit === 'mm' ? 500 : 20"
                 [step]="unit === 'mm' ? 1 : 0.25">
          <span matSuffix>{{unit === 'mm' ? 'mm' : '"'}}</span>
        </mat-form-field>
        <button mat-icon-button
                (click)="saveCustomTrim()"
                [disabled]="!customTrimChanged"
                i18n-title="@@Save" title="Save">
          <mat-icon>check</mat-icon>
        </button>
        <button mat-icon-button
                (click)="cancelCustomTrim()"
                i18n-title="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel" title="Cancel">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Margins - Hidden in compact mode -->
      <div *ngIf="toolbarExpanded" class="more-options-area">
        <label class="margin-grid-label" i18n="@@Margins">Margins</label>
        <div class="margin-grid">
          <div class="margin-grid-cell">
            <label i18n="@@Top">Top</label>
            <input type="number" [ngModel]="roundHundredths(draftBody.marginTop / unitMultiplier)" (change)="changeMargin('marginTop', $event.target.value)" step="0.01">
          </div>
          <div class="margin-grid-cell">
            <label i18n="@@Bottom">Bottom</label>
            <input type="number" [ngModel]="roundHundredths(draftBody.marginBottom / unitMultiplier)" (change)="changeMargin('marginBottom', $event.target.value)" step="0.01">
          </div>
          <div class="margin-grid-cell">
            <label i18n="@@Outside">Outside</label>
            <input type="number" [ngModel]="roundHundredths(draftBody.marginOut / unitMultiplier)" (change)="changeMargin('marginOut', $event.target.value)" step="0.01">
          </div>
          <div class="margin-grid-cell">
            <label i18n="@@Inside">Inside</label>
            <input type="number" [ngModel]="roundHundredths(draftBody.marginIn / unitMultiplier)" (change)="changeMargin('marginIn', $event.target.value)" step="0.01">
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div class="toggle-buttons">
        <button mat-icon-button
          (click)="toggleMarginCheck()"
          [class.toggled]="showMarginCheck"
          i18n-title="@@Toggle Margin Lines" title="Toggle Margin Lines">
          <mat-icon>border_inner</mat-icon>
        </button>

        <button mat-icon-button
          (click)="toggleRulers()"
          [class.toggled]="showRulers"
          i18n-title="@@Toggle Rulers" title="Toggle Rulers">
          <mat-icon>straighten</mat-icon>
        </button>

        <button mat-icon-button
          (click)="toggleGutter()"
          [class.toggled]="showGutter"
          i18n-title="@@Toggle Spine Gutter" title="Toggle Spine Gutter">
          <mat-icon>book</mat-icon>
        </button>

        <button mat-icon-button
          (click)="togglePageNumbers()"
          [class.toggled]="showPageNumbers"
          i18n-title="@@Toggle Page Numbers" title="Toggle Page Numbers">
          <mat-icon>tag</mat-icon>
        </button>

        <button mat-icon-button
          (click)="toggleDebugGrid()"
          [class.toggled]="showDebugGrid"
          i18n-title="@@Toggle Grid Lines" title="Toggle Grid Lines">
          <mat-icon>grid_on</mat-icon>
        </button>
      </div>

    </div>
    <div class="zoom-control-area">
      <label i18n="@@Zoom">Zoom</label>
      <input
        type="range"
        min="0.05"
        max="2.0"
        step="0.0125"
        [value]="scaleValue"
        (input)="onScaleChange($event)"
      >
      <span class="scale-indicator">{{ localizeNumber((scaleValue * 400).toFixed(0)) }}%</span>
    </div>

  </div></div>
